import generateMutation from '../../mutations/sales/SalesOrderLabelGenerateRangeMutation.graphql';

import { EntityType } from '../../../@types/entityTypes';
import { ReportType } from '../../schema/p4types';

const SalesOrderLabel: EntityType = {
  type: 'SalesOrderLabel',
  title: 'Sales Order Label',
  generateRange: generateMutation,
  screenReference: 'SALES_ORDER_LABEL',
  configuration: {
    title: 'Sales Order Labels',
    field: 'salesOrderLabelDefault',
    reportType: ReportType.SalesOrderLabel,
    alwaysEnabled: true,
  },
};

export default SalesOrderLabel;
